import {styled} from '@mui/system'

export const PatientStyled = styled('div')(({theme}) => ({
  height: '100%',
  gridArea: 'main',
  width: 'calc(100vw - (100vw - 100%))',
  overflow: 'hidden',
  background: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',

  '.layout-container-header': {
    backgroundColor: 'white',
    borderRadius: `${theme.spacing(20)} ${theme.spacing(20)} ${theme.spacing(0)} ${theme.spacing(0)}`,
    padding: `${theme.spacing(15)} ${theme.spacing(10)} ${theme.spacing(10)} ${theme.spacing(10)}`,
    display: 'flex',
    gap: theme.spacing(4),
    alignItems: 'center',

    '.avatar': {
      width: '120px',
      height: '120px',
      borderRadius: '50%',
      backgroundColor: theme.palette.primary[100],
      img: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        borderRadius: '50%'
      }
    },

    '> div': {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },

    '.label': {
      textShadow: 'none',
      width: 'fit-content',
      color: '#fff',
      fontSize: '13px',
      padding: `${theme.spacing(3)} ${theme.spacing(10)}`,
      borderRadius: '20px',
      backgroundColor: theme.palette.primary.main,
      fontWeight: '600'
    }
  },

  '.layout-container-body': {
    flex: 1,
    overflow: 'auto',
    backgroundColor: 'white',
    padding: `0px ${theme.spacing(8)} ${theme.spacing(8)} ${theme.spacing(8)}`,

    '.MuiTabPanel-root': {
      padding: '24px',
      border: '1px solid #DDD'
    },

    '.MuiTabs-flexContainer': {
      justifyContent: 'flex-start'
    }
  },

  '.layout-container-footer': {
    margin: '15px',
    background: '#F0F3F4',
    fontStyle: 'italic',
    flexShrink: 0
  }

}))
